import {
  Component,
  Inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CloseCaseDialogData {
  targetStatus: 'CONCLUIDA' | 'DESESTIMADA';
  statusLabel: string;
}

export interface CloseCaseResult {
  finalMessage: string;
  notes?: string;
  attachmentKeys: string[];
}

@Component({
  selector: 'app-close-case-dialog',
  templateUrl: './close-case-dialog.component.html',
  styleUrls: ['./close-case-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseCaseDialogComponent {
  finalMessage = '';
  notes = '';
  files: { storageKey: string; fileName: string; fileSize: number; fileType: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<CloseCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CloseCaseDialogData,
    private cdr: ChangeDetectorRef,
  ) {}

  onFilesChanged(files: any[]): void {
    this.files = files;
    this.cdr.markForCheck();
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    if (!this.finalMessage.trim()) return;
    const result: CloseCaseResult = {
      finalMessage: this.finalMessage.trim(),
      notes: this.notes.trim() || undefined,
      attachmentKeys: this.files.map((f) => f.storageKey),
    };
    this.dialogRef.close(result);
  }
}
